import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'boulder',
      d: 'M-5.5,-0.5h0.5v0.5h-0.5zM5,-0.5h0.5v1h-0.5zM-5.5,0h1v0.5h-1zM-5.5,0.5h1.5v0.5h-1.5zM4,0.5h1.5v0.5h-1.5zM-5,1h2.5v0.5h-2.5zM2,1h3v0.5h-3zM-4,1.5h8v0.5h-8zM-3,2h6v0.5h-6z',
    },
    {
      paint: 'epicMarble',
      d: 'M-2.5,-3h0.5v0.5h-0.5zM-4.5,-2.5h7.5v0.5h-7.5zM-3.5,-2h6.5v0.5h-6.5zM-5.5,-1.5h0.5v1h-0.5zM4.5,-1.5h0.5v0.5h-0.5zM4,-1h1.5v0.5h-1.5zM-5,-0.5h1v0.5h-1zM4,-0.5h1v0.5h-1zM-4.5,0h1v0.5h-1zM3.5,0h1v0.5h-1zM-4,0.5h2.5v0.5h-2.5zM1,0.5h3v0.5h-3zM-2.5,1h4.5v0.5h-4.5z',
    },
    {
      paint: 'waterLight',
      d: 'M-3,-1.5h6v0.5h-6zM-3.5,-1h1.5v0.5h-1.5zM-1,-1h1v0.5h-1zM3,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM3,-0.5h1v0.5h-1zM-3.5,0h1v0.5h-1zM1.5,0h2v0.5h-2zM-1.5,0.5h2.5v0.5h-2.5z',
    },
    {
      paint: 'epicCrystal',
      d: 'M-2,-1h1v0.5h-1zM0,-1h3v0.5h-3zM-3,-0.5h6v0.5h-6zM-2.5,0h4v0.5h-4z',
    },
    {
      paint: 'rock',
      d: 'M3,-2.5h1v0.5h-1zM-5,-2h1.5v0.5h-1.5zM3,-2h1.5v1h-1.5zM-5,-1.5h2v0.5h-2zM-5,-1h1.5v0.5h-1.5zM3.5,-1h0.5v0.5h-0.5zM4.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'snowCap',
      d: 'M-2.5,-6h0.5v1.5h-0.5zM0.5,-6h0.5v1h-0.5zM0,-5h1v1h-1zM-3,-4.5h1v0.5h-1zM-3,-4h0.5v1.5h-0.5zM0,-4h0.5v1h-0.5zM2,-4h0.5v0.5h-0.5zM2,-3.5h1v0.5h-1zM2,-3h0.5v0.5h-0.5z',
    },
  ],
  pixels: 214,
};
export const sprites: readonly PixelSprite[] = [variant0];
